import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import style from './key-value-select.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { DEFAULTS } from '../../ship-from/components/ship-from-dropdown/constants';
import { ValidationPropType } from '../../ship-from/components/ship-from-dropdown/prop-types';

const messages = defineMessages({
  selectItem: {
    description: 'keyValueSelect.selectItem',
    defaultMessage: 'Select Item',
    id: 'RbT6NK',
  },
});

const KeyValueSelect = ({
  items = emptyArray,
  label = '',
  onChange = noop,
  selectItemTranslation = '',
  selectedItem = '',
  validation = DEFAULTS.validation,
}) => {
  const { helperText, helperTextType } = validation;
  const intl = useIntl();
  const matchingItem = items.find((i) => i.value === selectedItem);
  const title = matchingItem ? matchingItem.key : intl.formatMessage(selectItemTranslation || messages.selectItem);

  return (
    <>
      <Text textType={TextType.Label} value={label} />
      <DropdownMenu
        dropdownMenuShouldHaveWidthOfButton
        fullWidth
        inlineMessage={helperText}
        inlineMessageType={helperTextType}
        variant='form'
      >
        <DropdownMenuToggler>{title}</DropdownMenuToggler>
        {items.map((item, index) => (
          <DropdownMenuItem key={index} onClick={() => onChange(item.value)} selected={item.value === selectedItem}>
            <span className={style['key-text']}>{item.key}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </>
  );
};

KeyValueSelect.propTypes = {
  items: PropTypes.array,
  label: PropTypes.oneOfType([MessageDescriptorPropType, PropTypes.string]),
  onChange: PropTypes.func,
  selectItemTranslation: PropTypes.string,
  selectedItem: PropTypes.string,
  validation: ValidationPropType,
};

export default KeyValueSelect;
